import { render, staticRenderFns } from "./DetailLessons.vue?vue&type=template&id=dd6be050"
import script from "./DetailLessons.vue?vue&type=script&lang=js"
export * from "./DetailLessons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports